import { Injectable, signal, Type } from '@angular/core';
import { BuilderState, SaveDialogState } from './builder.types';
@Injectable({
    providedIn: 'root'
})
export class BuilderManagerService {
    // Builder state
    private _builderState = signal<BuilderState | undefined>(undefined);
    // State for showing warning of unsaved changes
    private _unsavedWarningStateSignal = signal<SaveDialogState[]>([]);
    // Indicates that a report is being edited - carries the id
    public editReportSignal = signal<string>('');

    public get state() {
        return this._builderState();
    }

    public set state(value: BuilderState | undefined) {
        this._builderState.set(value);
    }

    /**
     * @summary Gets the currently set builder component or null if none is defined.
     * @returns The current builder component or null.
     */
    public get builderComponent(): Type<unknown> | undefined {
        return this._builderState()?.builderComponent;
    }

    public unsavedWarningStateData(state: SaveDialogState): void {
        this._unsavedWarningStateSignal.set([...this._unsavedWarningStateSignal(), state]);
    }

    public deleteFromUnsavedWarningState(state: SaveDialogState): void {
        const updatedState = this._unsavedWarningStateSignal().filter((el: SaveDialogState) => el.tabId !== state.tabId);
        this._unsavedWarningStateSignal.set([...updatedState]);
    }

    public isExistInUnsavedWarningState(tabId: string): boolean {
        const stateEntry = this._unsavedWarningStateSignal().find(el => el.tabId === tabId);
        return stateEntry !== undefined;
    }
}
